export default {
  'RenderModule': () => import('./Map/Render/RenderModule'),
}
